import { styled, Box } from "@mui/material";

const MessageListWrapper = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  marginTop: 10,
  overflowY: "auto",
  paddingInlineStart: 10,
  paddingInlineEnd: 10,
  borderBottom: "1px solid #b3b9c3ff",
  paddingTop: "10px",
  paddingRight: "10px",
  paddingLeft: "10px",
  paddingBottom: "16px",
}));

export default MessageListWrapper;
